import React from 'react'
import PropTypes from 'prop-types'
import { orderBy } from 'lodash'
import { withFirebase, withReloadable } from '../../hoc'
const OrderEventsContext = React.createContext({})

class OrderEventsFeed extends React.Component {
    _observer = null
    state = { events: [], loading: true }

    _getChangesInfo = (changes) => {
        let results = []
        changes.forEach((change) => {
            results.push(change.doc.data())
        })
        return results
    }
    async componentDidMount () {
        try {
            const { firebase, orderId } = this.props;

            const _docRef = firebase.collection('order-events').doc(orderId).collection('order-changes')
            this._observer = _docRef.orderBy('ts', 'desc').onSnapshot(docSnapshot => {
                let changes = docSnapshot.docChanges()
                if (docSnapshot.docChanges().fromCache) {
                    return
                }
                this.setState({
                    events: this._getChangesInfo(changes),
                    loading: false
                });
            }, err => {
                console.log(`Encountered error: ${err}`)
            })
        } catch (error) {
            console.log(error)
            this.setState({
                loading: false
            });
        }
    }

    componentWillUnmount () {
        typeof this._observer === 'function' && this._observer()
    }

    render () {
        const { children } = this.props
        const { events, loading } = this.state
        // console.log('holahola', this.props)
        return (
            <OrderEventsContext.Provider value={{ events: orderBy(events, ['ts'], ['asc']), loading }}>
                {children}
            </OrderEventsContext.Provider>
        )
    }
}

OrderEventsFeed.propTypes = {
    children: PropTypes.any,
    firebase: PropTypes.object,
    orderId: PropTypes.string.isRequired
}

export const OrderEventsFeedConsumer = OrderEventsContext.Consumer
export default withReloadable(withFirebase(OrderEventsFeed), ['orderId'])
